import IUserApplicationsFilter from "interfaces/IUserApplicationsFilter";

const initialUserApplicationsFilter = () : IUserApplicationsFilter => ({
  applicationTypes: [],
  group: undefined,
  searchText: ""
});

export { initialUserApplicationsFilter };
